import Vue from "vue";

// import { events } from "@nuskin/ns-util";
import { UserService } from "@nuskin/ns-account";
import { isNullOrEmpty } from "@nuskin/ns-common-lib";

let NsProductUserService = Vue.prototype.$NsProductUserService;
if (!NsProductUserService) {
  const newEl = document.createElement("div");
  newEl.id = "ns-product-user-service";
  const serviceEl = document.body.appendChild(newEl);

  NsProductUserService = new Vue({
    name: "NsProductUserService",
    data() {
      return {
        isLoggedIn: false,
        user: null,
        userId: null,
        isDistributor: false,
        isPreferredCustomer: false,
        loading: true
      };
    },
    computed: {
      marketConfig() {
        return this.$NsProductAppService.marketConfig;
      },
      showWholeSalePricing() {
        return this.$NsProductAppService.showWholeSalePricing;
      },
      isWholesale() {
        return (
          this.isDistributor ||
          this.isPreferredCustomer ||
          this.showWholeSalePricing
        );
      },
      isUserWholesale() {
        return this.isDistributor || this.isPreferredCustomer;
      }
    },
    mounted() {
      this.addListeners();
    },
    destroyed() {
      this.removeListeners();
    },
    methods: {
      /**
       * Set current user
       */
      setUser() {
        if (this.$NsProductAppService.loading) {
          return;
        }

        this.loading = true;

        const user = UserService.getUser();
        this.isLoggedIn = UserService.isLoggedIn() && !isNullOrEmpty(user);
        if (this.isLoggedIn) {
          this.user = user;
          this.userId = user.id;
          this.isDistributor = user.isDistributor();
          this.isPreferredCustomer = user.isPreferredCustomer();
        } else {
          this.user = null;
          this.userId = null;
          this.isDistributor = false;
          this.isPreferredCustomer = false;
        }

        this.setUserTranslations();

        this.loading = false;
        this.$emit("user-changed", this.user);
      },

      setUserTranslations() {
        const translations = this.$NsProductAppService.translations;

        let userTranslations = {};

        if (this.user) {
          switch (this.user.accountType) {
            case "10":
              userTranslations.psv = translations.psvDist;
              break;
            case "20":
              userTranslations.psv = translations.psvCust;
              break;
            case "30":
              userTranslations.psv = translations.psvPfc;
              break;
            default:
              userTranslations.psv = translations.psvAnon;
              break;
          }
        } else {
          userTranslations.psv = translations.psvAnon;
        }

        this.$NsProductAppService.appendTranslations(userTranslations);
      },

      /**
       * Subscribe to events, should only be called when mounted
       */
      addListeners() {
        // watch app service finished loading
        this.$watch("$NsProductAppService.loading", () => this.setUser(), {
          immediate: true
        });

        // WARNING: events.subscribe wasn't always working here
        // listen to user changes
        // events.subscribe(events.authentication.LOGIN, this.setUser);
        // events.subscribe(events.authentication.LOGOUT, this.setUser);
      },

      /**
       * Unsubscribe to events, should only be called when destroyed
       */
      removeListeners() {
        // stop listening to user changes
        // events.unsubscribe(events.authentication.LOGIN, this.setUser);
        // events.unsubscribe(events.authentication.LOGOUT, this.setUser);
      }
    }
  }).$mount(serviceEl);

  Vue.prototype.$NsProductUserService = NsProductUserService;
}

export default NsProductUserService;
